import { k as a } from "./reactive-element-DZ4uc4cT-BmQGLYME-HcXnJBgK.js";
import { html as e } from "./index-CYA3oVVY-hqmzhX60.js";
import "./lit-element-Bwc3Q88e-BvvsTfdo-Ch2fLuxu.js";
import { re as s } from "./abstract-base-hYnPtNku-DvWH8d8i-lRUZ3Vlj.js";
const r = {
  beaconTagName: "beacon-error"
}, n = a`:host{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;display:grid;gap:var(--beacon-reference-space-3);grid-template-columns:auto 1fr}.error{align-self:start}`, o = class t extends s {
  constructor() {
    super(...arguments), this.beaconTagName = r.beaconTagName;
  }
  static get styles() {
    return [super.styles, n];
  }
  static renderIcon() {
    return e`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="error"
        role="img"
        aria-label="Error">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.57752 10.9999C1.22025 11.6187 1.22025 12.3811 1.57752 12.9999L5.92282 20.5262C6.28009 21.145 6.94034 21.5262 7.65487 21.5262H16.3455C17.06 21.5262 17.7203 21.145 18.0775 20.5262L22.4228 12.9999C22.7801 12.3811 22.7801 11.6187 22.4228 10.9999L18.0775 3.47363C17.7203 2.85483 17.06 2.47363 16.3455 2.47363H7.65487C6.94034 2.47363 6.28008 2.85483 5.92282 3.47363L1.57752 10.9999ZM11.2502 7.74989C11.2502 7.33568 11.586 6.99989 12.0002 6.99989C12.4144 6.99989 12.7502 7.33568 12.7502 7.74989V12.2499C12.7502 12.6641 12.4144 12.9999 12.0002 12.9999C11.586 12.9999 11.2502 12.6641 11.2502 12.2499V7.74989ZM13.0002 15.9999C13.0002 16.5522 12.5525 16.9999 12.0002 16.9999C11.4479 16.9999 11.0002 16.5522 11.0002 15.9999C11.0002 15.4476 11.4479 14.9999 12.0002 14.9999C12.5525 14.9999 13.0002 15.4476 13.0002 15.9999Z"
          fill="var(--beacon-system-color-icon-error, #DD3636)" />
      </svg>
    `;
  }
  render() {
    return e`
      <slot name="icon">${t.renderIcon()}</slot>
      <slot></slot>
    `;
  }
};
o.tagName = r.beaconTagName;
let g = o;
export {
  g as BeaconError
};
